import { Grid } from '@mui/material';
import { KeySearchParamsEnum } from 'enums';
import useChain from 'hooks/useChain';
import useCoinList, { UseCoinListProps } from 'hooks/useCoinList';
import useFilter from 'hooks/useFilter';
import usePagination from 'hooks/usePagination';
import useWalletApi from 'hooks/useWalletApi';
import _get from 'lodash/get';
import { useMemo } from 'react';
import ActionSection from './components/ActionSection';
import CoinListSection from './components/CoinListSection';
import StepSection from './components/StepSection';
import TotalBalanceSection from './components/StepSectionTotalBalanceSection';
import TransactionSection from './components/TransactionSection';

const HomePage = () => {
    const { currentPage } = usePagination();
    const { getValueFilter, dependenciesEffect } = useFilter();
    const filters = useMemo<UseCoinListProps>(() => ({ page: currentPage - 1 }), [currentPage]);
    const { data: coins, paging, isLoading, refetch, isRefetching } = useCoinList({ ...filters });

    const currentToken = useMemo(() => {
        const token = getValueFilter(KeySearchParamsEnum.TOKEN);
        return token ?? _get(coins, '[0].symbol', null);
    }, [dependenciesEffect, coins]);

    const { qGetBalanceData, qGetBalance } = useWalletApi({ chart: true });
    const isLoadingBalance = useMemo(() => qGetBalance.isLoading || qGetBalance.isRefetching, [qGetBalance]);
    const isLoadingCoinList = useMemo(() => isLoading || isRefetching, [isLoading, isRefetching]);

    const { dataChainList, dataChainSelectedListBySymbol, filterListChainBySymbol } = useChain({
        enableChainList: true,
        symbol: currentToken,
        enableFilterNetwork: true
    });

    const dataFilterChain = useMemo(() => {
        return filterListChainBySymbol(dataChainSelectedListBySymbol || [], dataChainList);
    }, [dataChainList, dataChainSelectedListBySymbol]);

    const handleRefetch = () => {
        refetch();
        qGetBalance.refetch();
    };

    return (
        <>
            <Grid container gap={2} sx={{ flexWrap: { md: 'nowrap', xs: 'wrap' } }}>
                <Grid item xs={12} md={4}>
                    <Grid container gap={2}>
                        <Grid item xs={12}>
                            <TotalBalanceSection onRefetch={handleRefetch} data={qGetBalanceData} isLoading={isLoadingBalance} />
                        </Grid>
                        <Grid item xs={12}>
                            <ActionSection />
                        </Grid>
                        <Grid item xs={12}>
                            <CoinListSection data={coins} paging={paging} isLoading={isLoadingCoinList} />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} md={8}>
                    <Grid container gap={2}>
                        <StepSection />
                    </Grid>
                    <Grid container gap={2}>
                        <Grid item xs={12} mt={4}>
                            <TransactionSection symbol={currentToken} dataChainList={dataFilterChain} />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
};

export default HomePage;
